module.exports = __webpack_public_path__ + "static/img/the-city.23e6da2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/the-city.svg
// module id = AFxB
// module chunks = 1